module.exports = __webpack_public_path__ + "static/media/MEMORIAL_PARK_Reglamento_Interno.d9645752.pdf";